import  { FC, useState } from 'react';
import {Col, Nav, Row, Tab} from 'react-bootstrap';
import Pageheader from '@oldDashboard/components/pageheader';
import 'swiper/css';
import LaunchGoalsTile from "./components/goals/LaunchGoalsTile.tsx";
import RecomendedActionsTile from "./components/goals/recommended-actions/RecommendedActionsTile.tsx";
import MotivationPrinciplesUtilizedTile from "./components/results/motivation-principles-utilized/MotivationPrinciplesUtilizedTile.tsx";
import GuidePostKPIsTile from "./components/results/GuidePostKPIsTile.tsx";
import FileUploadSummaryTile from "./components/file-upload/file-upload-summary/FileUploadSummaryTile.tsx";
import ListSizeOverTimeTile from "./components/file-upload/list-size-over-time/ListSizeOverTimeTile.tsx";
import ConstituentConversionsTile
    from "./components/data-deep-dive/consituent-conversions/ConstituentConversionsTile.tsx";
import Filters from '@oldDashboard/components/filters';
import LaunchDateTile from './components/file-upload/list-size-over-time/LaunchDateTile.tsx';
import TopPerformingNetworkTile from './components/results/TopPerformingNetworkTile.tsx';
import LauncKeyDatesSummary from './components/launch-keydates-summary/LauncKeyDatesSummary.tsx';
import EngagementsTeamTile from './components/engagements-team/engagementsTeam.tsx';
import ConversionLeadingIndicatorsTile from './components/conversion-leading-indicators/conversionLeadingIndicatorsTile.tsx';
import GuidePostsTop from './components/guideposts-cards/GuidePostTop.tsx';
import GuidepostRunning from './components/guideposts-cards/GuidepostRunning.tsx';
import CumulativeInvoiceTile from './components/cumulativeInvoice/cumulativeInvoiceTile.tsx';
import MessageCard from '@oldDashboard/components/MessageCard';
import ListSizeTile from './components/file-upload/ListSizeTile.tsx';
import  store  from '@oldDashboard/rootStore';
import { useSnapshot } from 'valtio';
import { useDocumentTitle } from '@/shared/hooks/useDocumentTitle';
import DashboardBanner from '@/modules/dashboard/banner/DashboardBanner';

const ClientDashboard: FC = () => {
    // "Legacy Dashboard" since MPN-1507. This is the old platform's client dashboard; the
    // new platform's is ClientDashboard, now "Partner Dashboard".
    useDocumentTitle('Legacy Dashboard');
    const [isLoading] = useState(false);
    const [error] = useState<string|null>(null);
    const { dashboardState, accountState } = store;
    const { launchDates, constituentsConversions, fileSummaryData } = dashboardState.state;
    const dashboardClient = dashboardState.state;
    const { show_launch_kpi } = dashboardClient.leadersIndicators;
    useSnapshot(dashboardState.state);
    const account = accountState.state;
    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }
    const keyDatesSizesCard = () => {
        let xxl=3;  let xl=6; let lg=6;
        if(!dashboardClient.cumulativeInvoice.visible) {
            xxl = 6;
            xl= 6;
            lg = 6;
        }
        return {
            xxl, xl, lg
        }
    }

    const { xxl, xl, lg } = keyDatesSizesCard();
    const conversionLaunchGoalsSizesCard = () => {
        let lg_xxl=3, lg_xl=3, lg_l=6, lg_m=6;
        if(dashboardClient.recommendedActions.data.length == 0) {
            lg_xxl = 6;
            lg_xl=6;
            lg_l=12;
            lg_m=12;
        }
        if(!show_launch_kpi && dashboardClient.recommendedActions.data.length == 0) {
            lg_xxl = 12;
            lg_xl=12;
            lg_l=12;
            lg_m=12;
        }
        if(!show_launch_kpi && dashboardClient.recommendedActions.data.length != 0) {
            lg_xxl = 6;
            lg_xl=6;
            lg_l=6;
            lg_m=6;
        }
        return {
            lg_xxl, lg_xl, lg_l, lg_m
        }
    }

    const { lg_xxl, lg_xl, lg_l, lg_m } = conversionLaunchGoalsSizesCard();
   
    return (
        <>
            {/* The live marketing banner, as on the Partner Dashboard (MPN-2320): full width above
                the page's padding. No preview here; the banner editor previews on the Partner Dashboard. */}
            <DashboardBanner preview={false} />
        <div style={{ padding: "0 24px" }}>
            {/* "Dashboards" stays: it is the section this page sits in, not the page's name. */}
            <Pageheader title="Legacy Dashboard" heading="Dashboards" active="Legacy Dashboard"/>
            {/* Goals and KPIs */}
            <Filters />
            <Row>
                <Col xxl={lg_xxl} xl={lg_xl} lg={lg_l} md={lg_m}>
                    <LaunchGoalsTile
                        launchGoal={dashboardClient.launchGoal}
                        affiliateSelected={account.affiliateSelected}
                        launchSelected={dashboardClient.launchSelected} 
                        timePeriodSelected={dashboardClient.timePeriodSelected}
                        searching={dashboardClient.searching}
                    />
                </Col>

                <ConversionLeadingIndicatorsTile
                    data={dashboardClient.leadersIndicators}
                    affiliateSelected={account.affiliateSelected}
                    timePeriods={dashboardClient.timePeriods}
                    timePeriodSelected={dashboardClient.timePeriodSelected}
                    launchSelected={dashboardClient.launchSelected}
                    searching={dashboardClient.searching}
                />
                
                <Col xxl={show_launch_kpi ? 3 : 6} xl={show_launch_kpi ? 6 : 12} lg={12}>
                    <RecomendedActionsTile
                        recommendedActions={dashboardClient.recommendedActions}
                        affiliateSelected={account.affiliateSelected}
                        launchSelected={dashboardClient.launchSelected} 
                        timePeriodSelected={dashboardClient.timePeriodSelected}
                        searching={dashboardClient.searching}
                    />
                </Col>
            </Row>
            {/* Top Performing Guide Posts */}
             <Row>
                <Col xxl={12} xl={12} lg={12}>
                <div className="nav ">
                    <h5 className="fw-semibold pt-2 pe-2">GuidePosts</h5>
                        <Tab.Container defaultActiveKey={"first"}>
                            <Nav className="nav nav-tabs nav-style-3 justify-content-start" defaultActiveKey="first">
                                <Nav.Item>
                                    <Nav.Link eventKey="first">Top Performing</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="second">Currently Running</Nav.Link>
                                </Nav.Item>
                            </Nav>
                            <Tab.Content className="w-100">
                                <Tab.Pane eventKey={"first"} className="tab-pane text-muted px-0" role="tabpanel">
                                    { 
                                        !dashboardClient.topGuideposts?.length &&
                                        <MessageCard title="Top Performing" message="At the moment, we don't have any Guideposts available for viewing. 
                                        However, we're continuously creating new content, so please check back soon for new additions!"/>
                                    }
                                    <GuidePostsTop 
                                        ideas={dashboardClient.topGuideposts}
                                        timePeriods={dashboardClient.timePeriods}
                                        affiliateSelected={account.affiliateSelected}
                                        launchSelected={dashboardClient.launchSelected} 
                                        timePeriodSelected={dashboardClient.timePeriodSelected}
                                        searching={dashboardClient.searching}
                                    />
                                </Tab.Pane>
                                <Tab.Pane eventKey={"second"} className="tab-pane text-muted px-0" role="tabpanel">
                                    { 
                                        !dashboardClient.runningIdeas?.length &&
                                        <MessageCard title="Currently Running" message="At the moment, we don't have any Guideposts available for viewing. 
                                        However, we're continuously creating new content, so please check back soon for new additions!"/>
                                    }
                                    <GuidepostRunning
                                        ideas={dashboardClient.runningIdeas}
                                        timePeriods={dashboardClient.timePeriods}
                                        affiliateSelected={account.affiliateSelected}
                                        launchSelected={dashboardClient.launchSelected} 
                                        timePeriodSelected={dashboardClient.timePeriodSelected}
                                        searching={dashboardClient.searching}
                                    />
                                </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                    </div>
                </Col>
            </Row> 
            {/* Performance */}
            <div className="mb-4 d-flex align-items-center justify-content-between">
                <h5 className="fw-semibold mb-0">Launch Insights</h5>
            </div>
            <Row>
                <Col xxl={3} xl={6} lg={6} md={6} sm={12}>
                    <GuidePostKPIsTile
                        totalGpSummary={dashboardClient.totalGpSummary}
                        engagementData={dashboardClient.engagementData}
                        timePeriods={dashboardClient.timePeriods}
                        affiliateSelected={account.affiliateSelected}
                        launchSelected={dashboardClient.launchSelected} 
                        timePeriodSelected={dashboardClient.timePeriodSelected}
                        searching={dashboardClient.searching}
                    />
                </Col>
                

                <Col xxl={3} xl={3} lg={6} md={6} sm={12}>
                    <TopPerformingNetworkTile
                        data={dashboardClient.topPerformingNetwork}
                        timePeriods={dashboardClient.timePeriods}
                        affiliateId={account.affiliateSelected}
                        launchSelected={dashboardClient.launchSelected} 
                        timePeriodSelected={dashboardClient.timePeriodSelected}
                        searching={dashboardClient.searching}
                    />
                </Col>
                <Col xxl={6} xl={6} lg={12} md={12} sm={12}>
                    <MotivationPrinciplesUtilizedTile
                        timePeriods={dashboardClient.timePeriods}
                        affiliateSelected={account.affiliateSelected}
                        launchSelected={dashboardClient.launchSelected} 
                        timePeriodSelected={dashboardClient.timePeriodSelected}
                        searching={dashboardClient.searching}
                    />
                </Col>
            </Row>
            <div className="mb-4 d-flex align-items-center justify-content-between">
                <h5 className="fw-semibold mb-0">Students Served</h5>
            </div>
            <Row>
                <Col xxl={3} xl={3} lg={3} md={3} sm={3}>
                    <FileUploadSummaryTile 
                        fileSummaryData={fileSummaryData}
                        affiliateSelected={account.affiliateSelected}
                        launchSelected={dashboardClient.launchSelected}
                        searching={dashboardClient.searching}
                    />
                </Col>
                <Col xxl={3} xl={3} lg={3} md={3} sm={3}>
                    <ListSizeTile
                        totalStudents={dashboardClient.totalStudents}
                        affiliateSelected={account.affiliateSelected}
                        launchSelected={dashboardClient.launchSelected} 
                        timePeriodSelected={dashboardClient.timePeriodSelected}
                        searching={dashboardClient.searching}
                    />
                </Col>
               
                <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                    <ListSizeOverTimeTile
                          affiliateSelected={account.affiliateSelected}
                          launchSelected = {dashboardClient.launchSelected}
                          timePeriodSelected = {dashboardClient.timePeriodSelected}
                          searching={dashboardClient.searching}
                    />
                </Col>
            </Row> 
          
            <div className="mb-4 d-flex align-items-center justify-content-between">
                <h5 className="fw-semibold mb-0">Launch Management</h5>
            </div>
            <Row>
                <Col xxl={3} xl={6} lg={6} md={12} sm={12}>
                    <LaunchDateTile 
                        launchDates = {launchDates} 
                        launchSelected = {dashboardClient.launchSelected}
                        timePeriodSelected = {dashboardClient.timePeriodSelected}
                        searching={dashboardClient.searching}
                        />
                </Col>
                
                <CumulativeInvoiceTile 
                    data = {dashboardClient.cumulativeInvoice} 
                    launchSelected = {dashboardClient.launchSelected}
                    timePeriodSelected = {dashboardClient.timePeriodSelected}
                    searching={dashboardClient.searching}
                />
                
                <Col xxl={xxl} xl={xl} lg={lg} md={12} sm={12}>
                    <LauncKeyDatesSummary 
                        data={dashboardClient.launchKeydates}
                        affiliateSelected={account.affiliateSelected}
                        timePeriods={dashboardClient.timePeriods}
                        timePeriodSelected={dashboardClient.timePeriodSelected}
                        launchSelected={dashboardClient.launchSelected}
                        searching={dashboardClient.searching}
                    />
                </Col>
                <Col xxl={3} xl={6} lg={6} md={12} sm={12}>
                    <EngagementsTeamTile 
                        engagementTeam={dashboardClient.engagementTeam}
                        affiliateSelected={account.affiliateSelected}
                        timePeriods={dashboardClient.timePeriods}
                        timePeriodSelected={dashboardClient.timePeriodSelected}
                        launchSelected={dashboardClient.launchSelected}
                        searching={dashboardClient.searching}
                    />
                </Col>
                
            </Row>
                    {
                        constituentsConversions.show_student_conversions_tile &&
                        <div className="mb-4 d-flex align-items-center justify-content-between">
                            <h5 className="fw-semibold mb-0">Data Deep Dive</h5>
                        </div>
                    }
                    <ConstituentConversionsTile
                        affiliateSelected={account.affiliateSelected}
                        data={constituentsConversions}
                        launchSelected = {dashboardClient.launchSelected}
                        searching={dashboardClient.searching}
                    />
        </div>
        </>
    );
};
export default (ClientDashboard);